<div class="user-dialog-content-wrapper dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{ title }}</span>
      <button
        mat-icon-button
        class="mat-icon-button white-fg"
        (click)="dialogRef.close()"
        aria-label="Close dialog"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <!--MRD: Amended validation to use the custom component validation-errors so we have consistent messages and style across the product-->

  <mat-tab-group>
    <mat-tab label="User Details">
      <ng-container *ngTemplateOutlet="userdetails"></ng-container>
    </mat-tab>

    <mat-tab label="User Options">
      <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar>
        <form
          class="addDialog"
          [formGroup]="form"
          #formControl="ngForm"
          fxLayout="column"
          fxFlex
        >
          <mat-form-field>
            <mat-label>Role</mat-label>
            <mat-select
              id="role"
              class="form-control"
              formControlName="role"
              name="role"
            >
              <mat-option *ngFor="let item of userRoles" [value]="item.value">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field color="accent">
            <mat-label>Cost Per Hour</mat-label>
            <input
              matInput
              #input
              type="number"
              min="0"
              max="99999"
              step="any"
              class="form-control"
              placeholder="Cost Per Hour"
              formControlName="costPerHour"
              oninput="(validity && validity.valid)||(value='');"
            />
          </mat-form-field>

          <mat-checkbox
            id="chkCanLogin"
            formControlName="canLogin"
            name="canLogin"
            (change)="chkCanLogin_changed($event)"
            >Can Login</mat-checkbox
          >

          <mat-checkbox
            id="chkreceiveNewReferralNotifications"
            *ngIf="showUserReferralNotificationsUI"
            [disabled]="getReceiveNewReferralNotificationDisabled()"
            formControlName="receiveNewReferralNotifications"
            name="receiveNewReferralNotifications"
            >Receive Referral Notifications</mat-checkbox
          >

          <mat-checkbox
            id="chkReceiveRetentionNotifications"
            [disabled]="this.IsAdmin == false"
            formControlName="receiveRetentionNotifications"
            name="receiveRetentionNotifications"
            >Receive Retention Notifications</mat-checkbox
          >

          <mat-checkbox
            id="chkCanViewArchive"
            [disabled]="this.IsAdmin == false"
            formControlName="canViewArchive"
            name="canViewArchive"
            >Can View Archive
          </mat-checkbox>

          <mat-checkbox
            id="chkCanDeleteAttachments"
            [disabled]="this.IsAdmin == false"
            formControlName="canDeleteAttachments"
            name="canDeleteAttachments"
            >Can Delete Attachments
          </mat-checkbox>

          <mat-checkbox
            id="chkCanCloseCases"
            [disabled]="this.IsAdmin == false || !requirePermissionToCloseCases"
            formControlName="canCloseCases"
            name="canCloseCases"
            >Can Close Cases
          </mat-checkbox>

          <mat-checkbox
            id="chkCanExportData"
            [disabled]="this.IsAdmin == false"
            formControlName="canExportData"
            name="canExportData"
            >Can Export Data
          </mat-checkbox>

          <mat-checkbox
            *ngIf="hyperLawModuleActive"
            id="chkHasCasePrepAccess"
            [disabled]="this.IsAdmin == false"
            formControlName="hasCasePrepAccess"
            name="hasCasePrepAccess"
          >
            Has Case Preparation Access
          </mat-checkbox>

          <!-- PJT - Add MultiOrgAdmin START -->
          <mat-form-field
            *ngIf="
              editingSelf == false &&
              organisations.length > 0 &&
              this.form.controls['role'].value.toLowerCase() == 'multiorgadmin'
            "
          >
            <mat-label>Linked Organisations</mat-label>
            <mat-select multiple formControlName="userOrganisations">
              <mat-option
                *ngFor="let org of this.organisations"
                [value]="org.id"
                >{{ org.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <validation-errors
            [control]="form.get('userOrganisations')"
          ></validation-errors>
          <!-- PJT - Add MultiOrgAdmin END -->
        </form>
      </div>
    </mat-tab>
  </mat-tab-group>

  <ng-template #userdetails>
    <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar>
      <form
        class="addDialog"
        [formGroup]="form"
        #formControl="ngForm"
        fxLayout="column"
        fxFlex
      >
        <mat-form-field color="accent">
          <mat-label>First Name</mat-label>
          <input
            id="txtFirstName"
            matInput
            #input
            class="form-control"
            formControlName="firstName"
            name="firstName"
            required
            [setFocus]="true"
          />
        </mat-form-field>
        <validation-errors
          [control]="form.get('firstName')"
        ></validation-errors>
        <!--Unique combinator check is performed on form, so make sure we display form errors as well as control errors-->
        <validation-errors [control]="form"></validation-errors>

        <mat-form-field color="accent">
          <mat-label>Last Name</mat-label>
          <input
            id="txtLastName"
            matInput
            #input
            class="form-control"
            formControlName="lastName"
            name="lastNaame"
            required
          />
        </mat-form-field>
        <validation-errors [control]="form.get('lastName')"></validation-errors>
        <!--Unique combinator check is performed on form, so make sure we display form errors as well as control errors-->
        <validation-errors [control]="form"></validation-errors>

        <mat-form-field color="accent">
          <mat-label>Email Address</mat-label>
          <input
            id="txtEmailAddress"
            matInput
            #input
            class="form-control"
            formControlName="emailAddress"
            name="emailAddress"
            required
          />
        </mat-form-field>
        <validation-errors
          [control]="form.get('emailAddress')"
        ></validation-errors>

        <mat-form-field color="accent">
          <mat-label>Telephone</mat-label>
          <input
            id="txtTelephone"
            matInput
            #input
            class="form-control"
            formControlName="telephone"
            name="telephone"
          />
        </mat-form-field>

        <mat-form-field color="accent">
          <mat-label>Mobile</mat-label>
          <input
            id="txtMobile"
            matInput
            #input
            class="form-control"
            formControlName="mobile"
            name="mobile"
          />
        </mat-form-field>

        <mat-form-field color="accent">
          <mat-label>Address Line 1</mat-label>
          <input
            id="txtAddressLine1"
            matInput
            #input
            class="form-control"
            formControlName="addressLine1"
            name="addressLine1"
          />
        </mat-form-field>

        <mat-form-field color="accent">
          <mat-label>Address Line 2</mat-label>
          <input
            id="txtAddressLine2"
            matInput
            #input
            class="form-control"
            formControlName="addressLine2"
            name="addressLine2"
          />
        </mat-form-field>

        <mat-form-field color="accent">
          <mat-label>Address Line 3</mat-label>
          <input
            id="txtAddressLine3"
            matInput
            #input
            class="form-control"
            formControlName="addressLine3"
            name="addressLine3"
          />
        </mat-form-field>

        <mat-form-field color="accent">
          <mat-label>Address Line 4</mat-label>
          <input
            id="txtAddressLine4"
            matInput
            #input
            class="form-control"
            formControlName="addressLine4"
            name="addressLine4"
          />
        </mat-form-field>

        <mat-form-field color="accent">
          <mat-label>Address Line 5</mat-label>
          <input
            id="txtAddressLine5"
            matInput
            #input
            class="form-control"
            formControlName="addressLine5"
            name="addressLine5"
          />
        </mat-form-field>

        <mat-form-field color="accent">
          <mat-label>Postcode</mat-label>
          <input
            id="txtPostcode"
            matInput
            #input
            class="form-control"
            formControlName="postcode"
            name="postcode"
          />
        </mat-form-field>

        <mat-form-field *ngIf="editingSelf == false">
          <mat-label>Manager</mat-label>
          <mat-select
            id="managerId"
            class="form-control"
            formControlName="managerId"
            name="managerId"
          >
            <mat-option [value]="undefined">None</mat-option>
            <mat-option *ngFor="let item of userList" [value]="item.id">
              {{ item?.fullName || 'Unspecified User' }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          *ngIf="
            editingSelf == false &&
            organisations.length > 0 &&
            this.form.controls['role'].value.toLowerCase() != 'multiorgadmin'
          "
        >
          <mat-label>Organisation</mat-label>
          <mat-select
            id="organisationId"
            class="form-control"
            formControlName="organisationId"
            [disabled]="this.IsOrgAdmin == true || this.IsAdmin == false"
            name="organisationId"
            [required]="getOrgIsRequired()"
          >
            <mat-option [value]="null" *ngIf="!getOrgIsRequired()">
              None
            </mat-option>
            <mat-option *ngFor="let org of this.organisations" [value]="org.id">
              {{ org.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <validation-errors
          *ngIf="
            editingSelf == false &&
            organisations.length > 0 &&
            this.form.controls['role'].value.toLowerCase() != 'multiorgadmin'
          "
          [control]="form.get('organisationId')"
        ></validation-errors>
      </form>
    </div>
  </ng-template>

  <div
    mat-dialog-actions
    class="m-0 p-24"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <div>
      <button
        mat-raised-button
        id="btnSaveProfile"
        type="submit"
        [disabled]="!form.valid || form.pristine"
        [mat-dialog-close]="1"
        (click)="confirmSubmit()"
        class="save-button mat-accent"
        aria-label="SAVE"
      >
        SAVE
      </button>
    </div>
  </div>
</div>
